/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import HTMLFlipBook from 'react-pageflip'
import { Button, Image } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMaximize, faXmark, faBars } from '@fortawesome/free-solid-svg-icons'
import { mobilePhone, wavenet_logo } from '../asset'
import CIIcon from './CIIcon'

function PageFlipWithBannerPreview({ srcs, redirectUrl }) {
  const [showIntro, setShowIntro] = useState(true)
  const [showFlip, setShowFlip] = useState(false)
  const [visible, setVisible] = useState(true)
  const [rightIndex, setRightIndex] = useState(0)
  const wheelLockRef = useRef(false)
  const flipRef = useRef(null)

  const intro = srcs.find((s) => s.label === 'Intro video')
  const bottomImg = srcs.find((s) => s.label === 'Bottom img')

  const rightImgs = srcs
    .filter((s) => s.label?.startsWith('Right img'))
    .sort(
      (a, b) =>
        parseInt(a.label.match(/\d+/)?.[0], 10) -
        parseInt(b.label.match(/\d+/)?.[0], 10)
    )

  const expandImgs = srcs
    .filter((s) => s.label?.startsWith('Expand img'))
    .sort(
      (a, b) =>
        parseInt(a.label.match(/\d+/)?.[0], 10) -
        parseInt(b.label.match(/\d+/)?.[0], 10)
    )

  const getPreviewURL = (file) => {
    if (file instanceof File || file instanceof Blob)
      return URL.createObjectURL(file)
    if (typeof file === 'string') return file
    return ''
  }

  useEffect(() => {
    if (intro?.file) {
      const timer = setTimeout(() => setShowIntro(false), 3000)
      return () => clearTimeout(timer)
    }
    setShowIntro(false)
    return undefined
  }, [intro])

  if (!visible) return null

  const handleWheel = (e) => {
    if (wheelLockRef.current) return

    wheelLockRef.current = true
    setTimeout(() => {
      wheelLockRef.current = false
    }, 500)

    const total = rightImgs.length
    if (total === 0) return

    setRightIndex((prev) => {
      if (e.deltaY > 0) return (prev + 1) % total
      return (prev - 1 + total) % total
    })
  }

  return (
    <div
      className="scroller-hide"
      style={{ maxHeight: '57.5vh', overflow: 'auto' }}
      onWheel={handleWheel}
    >
      {/* 手機邊框與導覽列 */}
      <div className="w-100 pb-1">
        <Image
          className="position-absolute"
          src={mobilePhone}
          style={{ width: '19.5rem', right: '16%', top: '2%' }}
        />
        <div style={{ position: 'relative' }}>
          <div
            className="border-bottom mb-3 d-flex"
            style={{ width: '240px', height: '55px', zIndex: '0' }}
          >
            <div className="w-80 m-auto ms-auto">
              <Image src={wavenet_logo} className="w-75 ps-3" />
            </div>
            <div className="w-20 m-auto ms-auto d-flex">
              <FontAwesomeIcon icon={faBars} className="text-end" />
            </div>
          </div>
          <div className="text-title" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-ban1" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line2" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <br />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <br />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <br />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <br />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
        </div>
      </div>

      {/* Intro Video */}
      {showIntro && intro?.file && (
        <video
          src={getPreviewURL(intro.file)}
          autoPlay
          muted
          playsInline
          style={{
            width: '240px',
            position: 'absolute',
            bottom: '12%',
            right: '19%',
            zIndex: 2000,
            backgroundColor: '#000',
          }}
        />
      )}

      {/* Bottom Image + Right Images（整塊可點擊展開 flip） */}
      {!showIntro && !showFlip && (
        <div
          role="presentation"
          onClick={() => setShowFlip(true)}
          style={{
            position: 'absolute',
            bottom: '11%',
            right: '19%',
            width: '240px',
            cursor: 'pointer',
          }}
        >
          {/* Close Button（左上） */}
          <Button
            onClick={(e) => {
              e.stopPropagation()
              setVisible(false)
            }}
            style={{
              position: 'absolute',
              top: '-30px',
              left: '6px',
              background: 'rgba(0,0,0,0.5)',
              border: 'none',
              borderRadius: '50%',
              color: '#fff',
              width: '23px',
              height: '23px',
              fontSize: '12px',
              zIndex: 9999,
              padding: '2px',
              cursor: 'pointer',
            }}
          >
            <FontAwesomeIcon icon={faXmark} />
          </Button>

          {/* Expand Button（右上） */}
          <Button
            onClick={(e) => {
              e.stopPropagation()
              setShowFlip(true)
            }}
            style={{
              position: 'absolute',
              top: '-30px',
              right: '6px',
              background: 'white',
              border: '1px solid #000',
              borderRadius: '50%',
              padding: '4px 8px',
              fontSize: '14px',
              zIndex: 9999,
              cursor: 'pointer',
            }}
          >
            <FontAwesomeIcon
              icon={faMaximize}
              className="text-dark animate-pulse"
            />
          </Button>

          <img
            src={getPreviewURL(bottomImg?.file)}
            alt="Bottom"
            className="w-100"
            style={{ pointerEvents: 'none' }}
          />

          {/* Right-side 3D Stack */}
          <div
            onWheel={handleWheel}
            style={{
              position: 'absolute',
              top: 0,
              right: 0,
              width: '50%',
              height: '100%',
              zIndex: 1100,
              perspective: '1000px',
              overflow: 'visible',
            }}
          >
            {rightImgs.map((img, i) => {
              const isActive = i === rightIndex
              const isPast = i < rightIndex
              const isFuture = i > rightIndex

              let rotation = 0
              if (isPast) rotation = 90
              else if (isActive) rotation = 0
              else rotation = 60 - (i - rightIndex) * 5

              const translateZ = isActive ? 0 : -10 * (i - rightIndex)

              return (
                <img
                  key={`right-img-${i}`}
                  src={getPreviewURL(img.file)}
                  alt={`Right ${i + 1}`}
                  style={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    transition: 'transform 0.6s ease, opacity 0.6s ease',
                    opacity: isPast ? 0 : 1,
                    transform: `rotateY(${rotation}deg) translateZ(${translateZ}px)`,
                    transformOrigin: 'bottom right',
                    zIndex: 100 - i,
                    // boxShadow: !isActive
                    //   ? '0 3px 10px rgba(0,0,0,0.3)'
                    //   : 'none',
                    filter: isFuture ? 'brightness(0.92) blur(0.5px)' : 'none',
                    pointerEvents: 'none',
                  }}
                />
              )
            })}
            <CIIcon />
          </div>
        </div>
      )}

      {/* Page Flip 展開 */}
      {!showIntro && showFlip && (
        <div
          style={{
            position: 'absolute',
            bottom: '15%',
            right: '8.5%',
            transform: 'translateX(-50%)',
            width: '240px',
            zIndex: 1100,
          }}
        >
          <div
            role="presentation"
            onClick={() => {
              if (redirectUrl) window.open(redirectUrl, '_blank')
            }}
            style={{
              position: 'absolute',
              bottom: '15%',
              right: '0%',
              transform: 'translateX(0%)',
              width: '240px',
              zIndex: 1100,
            }}
          >
            <Button
              onClick={(e) => {
                e.stopPropagation()
                setShowFlip(false)
              }}
              style={{
                position: 'absolute',
                top: '-24px',
                right: '5px',
                zIndex: 1101,
                width: '22px',
                height: '22px',
                border: 'none',
                borderRadius: '50%',
                backgroundColor: 'rgb(0 0 0 / 50%)',
                fontSize: '14px',
                lineHeight: '24px',
                cursor: 'pointer',
                padding: '0px 10px 5px 8px',
                alignContent: 'center',
              }}
            >
              ✕
            </Button>

            <HTMLFlipBook
              ref={flipRef}
              width={240}
              height={360}
              size="stretch"
              minWidth={240}
              maxWidth={240}
              minHeight={360}
              maxHeight={360}
              showCover={false}
              usePortrait
              drawShadow={false}
              flippingTime={1000}
              startPage={0}
              style={{ width: '100%', height: '100%' }}
              onFlip={(e) => {
                const current = e.data
                const total = expandImgs.length
                if (current === total - 1 && redirectUrl) {
                  setTimeout(() => {
                    window.open(redirectUrl, '_blank')
                  }, 1000)
                }
              }}
            >
              {expandImgs.map((img, i) => (
                <div key={`expand-${i}`}>
                  <img
                    src={getPreviewURL(img.file)}
                    alt={`Page ${i + 1}`}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                  />
                  <CIIcon />
                </div>
              ))}
            </HTMLFlipBook>
          </div>
        </div>
      )}
    </div>
  )
}

PageFlipWithBannerPreview.propTypes = {
  srcs: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
      ]),
      label: PropTypes.string,
    })
  ).isRequired,
  redirectUrl: PropTypes.string,
}

PageFlipWithBannerPreview.defaultProps = {
  redirectUrl: '',
}

export default PageFlipWithBannerPreview
